<template>
  <div class="select-custom">
    <label v-if="label">{{ label }}</label>
    <div
      class="select-content"
      :class="{ active: isDropdownOpen }"
      @mouseleave="closeDropdown"
    >
      <div class="select-toggle" @click="toggleDropdown">
        <span>{{ getDisplayText(selectedOption?.label) || getDisplayText(placeholder) }}</span>
        <span
          v-if="isDropdownOpen"
          class="material-symbols-outlined active"
          translate="no"
          >expand_less</span
        >
        <span v-else class="material-symbols-outlined" translate="no"
          >expand_more</span
        >
      </div>
      <transition name="fade">
        <div v-show="isDropdownOpen" class="select-options">
          <div
            v-for="option in options"
            :key="option.value"
            @click="selectOption(option)"
            :class="{ active: modelValue === option.value }"
          >
            {{ getDisplayText(option.label) }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";

// Usamos la instancia completa de i18n para acceder a sus funciones
const i18n = useI18n();
const { t: $t } = i18n; // Mantenemos $t para el placeholder

const props = defineProps({
  options: { type: Array, default: () => [] },
  modelValue: String,
  label: String,
  placeholder: {
    type: String,
    default: "Select an option",
  },
});

const emit = defineEmits(["update:modelValue"]);

const isDropdownOpen = ref(false);

const selectedOption = computed(() => {
  return props.options.find((opt) => opt.value === props.modelValue) || null;
});

/**
 * Función dinámica para obtener el texto a mostrar.
 * Revisa si una traducción existe. Si existe, la devuelve.
 * Si no, devuelve el texto original.
 */
function getDisplayText(label) {
  if (!label) {
    return ""; // Devuelve vacío si no hay label
  }
  // `te` revisa si la clave de traducción ('translation exists')
  const translationExists = i18n.te(label);

  return translationExists ? $t(label) : label;
}

// Métodos del componente
function selectOption(option) {
  emit("update:modelValue", option.value);
  isDropdownOpen.value = false;
}

function toggleDropdown() {
  isDropdownOpen.value = !isDropdownOpen.value;
}

function closeDropdown() {
  isDropdownOpen.value = false;
}
</script>